import {
  Component,
  AfterContentInit,
  OnDestroy,
  ElementRef
} from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { UserService } from '../../user.service';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { ServiceLocator } from '../../ServiceLocator';
import { ProfileService } from '../../../services/profile.services';

@Component({
  selector: 'controlPanel',
  templateUrl: 'controlPanel.template.html'
})
export class controlPanelComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  loaded = false;
  // Opciones disponibles del panel de cotrol
  // Define:
  // - Todas las posibles
  // - Agrupaciones
  // - path
  // - queryparams
  // - perfiles de acceso por defecto

  configGroups: any;
  profileService: any;
  configGroupsConfigurations: any;

  constructor(
    public plycaService: PlycaDataService,
    public userService: UserService,
    public helpService: HelpService,
    public uiService: UIService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,

    public appConfig: AppConfiguration
  ) {
    super();
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.CONTROL_PANEL));
    this.profileService = ServiceLocator.injector.get(ProfileService);
    this.patchProfiles();
  }

  ngAfterContentInit(): void {
    this.headerActionsService.setTaskDescription(
      this.elem,
      'General.utils',
      'fas fa-cogs',
      true
    );
    this.headerActionsService.addDivider();
    this.subscribe(this.headerActionsService
      .addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ),
      success => {
        this.uiService.routeBack();
      });
    // this.loaded = true;
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.configGroups !== undefined;
  }

  protected patchProfiles() {
    // se recuperan todas la opciones y grupos
    this.configGroupsConfigurations = this.profileService.getControlPanelConfiguration();
    // Se agrupan
    let _groups = this.configGroupsConfigurations.filter(option => option.type === 'GROUP');
    _groups.forEach(group => {
      let _options = this.configGroupsConfigurations.filter(
        option => option.type === 'OPTION' && option.group === group.identifier
          && (option.profiles === undefined || option.profiles === '' || this.userService.hasRoles(option.profiles)));

      if (_options !== undefined && _options.length > 0) {
        group['options'] = _options;
      }

    });


    // Se eliminan los grupos que no tienen opciones con acceso
    this.configGroups = _groups.filter(g => { return g.options !== undefined; });
  }

  /*
    openURL(option: any) {



      //https://coryrylan.com/blog/managing-external-links-safely-in-angular
      //To solve both of these issues, any link using target="_blank" should also have a rel="noopener" attribute as well.
      //The rel="noopener" attribute makes sure that the new browser tab does not run on the same process and prevents it
      //from accessing window.opener.

      window.open(option.linkTo, 'target=_blank,rel="noopener"');



    }*/

}
